import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[800px] w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/b4c4685e5cedee7b9d5cfe7e4068bd31.jpg"
          alt="Vista panorâmica da Madeira"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <p className="text-nature-green bg-white/90 inline-block px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider mb-6">
              Madeira Island Escapes
            </p>
            
            <h1 className="text-white mb-6">
              <span className="block text-5xl md:text-6xl lg:text-7xl font-light mb-2">
                Descubra o seu
              </span>
              <span className="block text-5xl md:text-6xl lg:text-7xl font-serif italic font-normal mb-2">
                refúgio perfeito
              </span>
              <span className="block text-5xl md:text-6xl lg:text-7xl font-light">
                na Madeira
              </span>
            </h1>

            <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-8 max-w-2xl">
              Apartamentos modernos com vista mar e montanha, totalmente equipados para as suas férias de sonho. 
              Reserve direto e desfrute da melhor experiência na Ilha da Madeira.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/apartamentos"
                className="inline-flex items-center justify-center px-8 py-4 bg-sea-blue text-white rounded-full font-semibold text-base hover:bg-sea-blue/90 hover:shadow-xl transition-all whitespace-nowrap cursor-pointer group"
              >
                Reservar Agora
                <i className="ri-arrow-right-line ml-2 text-xl group-hover:translate-x-1 transition-transform"></i>
              </Link>
              
              <Link
                to="/apartamentos"
                className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold text-base hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer border-2 border-white/30"
              >
                Ver Apartamentos
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;